'use client';

import React from 'react';

interface PlanErrorBoundaryProps {
    children: React.ReactNode;
    fallback: React.ReactNode;
}

interface PlanErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

export class PlanErrorBoundary extends React.Component<PlanErrorBoundaryProps, PlanErrorBoundaryState> {
    constructor(props: PlanErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): PlanErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Plan component error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <>{this.props.fallback}</>;
        }

        return <>{this.props.children}</>;
    }
}

